// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2X1rH","additionalInfo":"AgreementModal_additionalInfo__FGEwC"};